'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidebarByCountry = undefined;

var _immutable = require('immutable');

var _author = require('bender-url!signup-ui/images/testimonials/us/author.png');

var _author2 = _interopRequireDefault(_author);

var _logo = require('bender-url!signup-ui/images/testimonials/us/logo.png');

var _logo2 = _interopRequireDefault(_logo);

var _author3 = require('bender-url!signup-ui/images/testimonials/in/author.png');

var _author4 = _interopRequireDefault(_author3);

var _logo3 = require('bender-url!signup-ui/images/testimonials/in/logo.png');

var _logo4 = _interopRequireDefault(_logo3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sidebarByCountry = exports.sidebarByCountry = (0, _immutable.Map)({
  us: (0, _immutable.Map)({
    image: _author2.default,
    logo: _logo2.default,
    message: '“HubSpot CRM has allowed us to <strong>track, manage, and organize our sales pipeline</strong> in a more efficient way than we ever thought possible.”',
    author: 'Mark Wallace',
    position: 'Co-Founder of Parlor'
  }),
  in: (0, _immutable.Map)({
    image: _author4.default,
    logo: _logo4.default,
    message: '“From generating traffic, growing leads, managing pipeline and closing deals, <strong>HubSpot has helped us scale our business</strong> without a huge capital investment.”',
    author: 'Vivek Khandelwal',
    position: 'Founder of iZootoo'
  })
});